/** Radix `Tooltip.Content` class — same styling as collapsed sidebar menu labels (`SidebarMenuLink`). */
export const radixTooltipContentClass =
    'z-[10000] max-w-[240px] rounded-md border border-[var(--neutral-color)] bg-[var(--white-color)] px-2.5 py-1.5 text-left text-[11px] 2xl:text-[12px] font-medium leading-snug text-[var(--secondary-color)] shadow-lg select-none';
